<template>
  <fb-list-body :pager="pager" :showSearchForm="true" :showBtnGroup="false"
                @handlePagerSizeChange="handlePagerSizeChange" @handlePagerIndexChange="handlePagerIndexChange">

    <template slot="other">
      <div style="display: flex">
        <el-upload
            :on-success="() => {this.loading = false}"
            :before-upload="onBeforeUpload"
            v-loading.fullscreen.lock="loading"
            :action="getAction()"
            :multiple="false"
            :show-file-list="false"
            ref="upload"
            :on-change="handleChangeFile"
            :limit="1">
          <el-button type="primary">{{ $t('lang.批量导入') }}</el-button>
        </el-upload>


        <el-button size="medium" type="primary" style="margin: 0 14px" @click.native="handleDownload">{{ $t('lang.下载模板') }}</el-button>
        <el-button icon="el-icon-delete" @click.native="handleBatchDelete">{{ $t('lang.删除') }}</el-button>
      </div>

    </template>

    <template slot="search-form">
      <div @keyup.enter="handleSearch">
        <el-row>
          <el-form-item class="search-form-item" :label="$t('lang.账户名')">
            <el-input :placeholder="$t('lang.账户名')" v-model="searchForm.account" clearable></el-input>
          </el-form-item>
          <el-form-item class="search-form-item" :label="$t('lang.用户编号')">
            <el-input :placeholder="$t('lang.用户编号')" v-model="searchForm.number" clearable></el-input>
          </el-form-item>

          <el-form-item class="search-form-item" :label="$t('lang.注册状态')">

            <el-select v-model="searchForm.status" :placeholder="$t('lang.请选择')">
              <el-option :label="$t('lang.已注册')" value="registered"></el-option>
              <el-option :label="$t('lang.未注册')" value="unregistered"></el-option>
            </el-select>
          </el-form-item>

        </el-row>

        <el-row>
          <el-form-item class="search-form-item" :label="$t('lang.创建时间')">
            <el-date-picker
                v-model="time"
                type="daterange"
                format="yyyy-MM-dd"
                value-format="yyyy-MM-dd"
                range-separator="~"
                :start-placeholder="$t('lang.开始日期')"
                :end-placeholder="$t('lang.结束日期')">
            </el-date-picker>
          </el-form-item>

          <el-form-item class="search-form-item" label="">
            <el-button size="mini" type="primary" icon="el-icon-search" @click.stop="handleSearch">{{$t('lang.搜索')}}</el-button>
            <el-button size="mini" type="primary" @click.stop="handleReset">{{$t('lang.重置')}}</el-button>
          </el-form-item>
        </el-row>
      </div>
    </template>


    <template slot="table">

      <el-table :data="tableData" @selection-change="handleSelectionChange">

        <el-table-column type="selection" width="50"></el-table-column>

        <el-table-column type="index" width="50"></el-table-column>

        <el-table-column prop="account" :label="$t('lang.账户名')"></el-table-column>
        <el-table-column prop="createTimeStr" :label="$t('lang.创建时间')" width="160"></el-table-column>
        <el-table-column :label="$t('lang.注册状态')">
          <template v-slot="{row}">
            {{$t(`lang.${row.statusName}`)}}
          </template>
        </el-table-column>
        <el-table-column prop="number" :label="$t('lang.用户编号')"></el-table-column>

        <el-table-column fixed="right" :label="$t('lang.操作')" width="180">
          <template slot-scope="scope">
            <el-button size="mini" plain type="danger" @click="handleDelete(scope.row)">{{ $t('lang.删除') }}</el-button>
          </template>
        </el-table-column>


      </el-table>
    </template>


  </fb-list-body>
</template>

<script>
import {downloadTemplate} from "../../js/common";
// import UploadFile from "../../components/upload-file/UploadFile";

export default {
  name: "VipUserList",
  components: {},
  props: {
    timestamp: {
      type: Number,
      default: function () {
        return new Date().getTime()
      }
    },
  },
  data() {
    return {
      api: {
        list: this.$api.vipUser.list,
        delete: this.$api.vipUser.delete,
        batchDelete: this.$api.vipUser.batchDelete,
        importData: this.$api.vipUser.importData,
      },
      searchForm: {},
      tableData: [],
      brandOwnerCode: '',
      selection: [],
      pager: {
        pageSize: 10,
        pageIndex: 1,
        itemCount: 0
      },
      time: '',
      loading: false,
    }
  },

  computed: {
    searchParams() {
      return Object.assign({}, this.$route.query, this.searchForm, this.pager);
    }
  },
  watch: {
    time: {
      handler(val) {
        const vm = this;
        if (val.length) {
          vm.searchForm['startTime'] = val[0];
          vm.searchForm['endTime'] = val[1];
        }
      },
      immediate: true,
      deep: true,
    },
    timestamp() {
      this.handleGetData();
    },
    "pager.pageIndex": {
      handler() {
        this.$router.updateQuery({
          path: this.$route.path,
          query: this.searchParams
        });
        this.handleGetData();

      },
      deep: true,
      immediate: true
    },
    "pager.pageSize": {
      handler() {

        this.$router.updateQuery({
          path: this.$route.path,
          query: this.searchParams
        });
        this.handleGetData();

      },
      deep: true
    }

  },
  methods: {
    getAction() {
      this.brandOwnerCode = JSON.parse(sessionStorage.getItem('login-user-info')).brandOwnerCode
      return this.api.importData + '?brandOwnerCode=' + this.brandOwnerCode
    },
    onBeforeUpload() {
      this.loading = true
    },
    handleDownload() {
      downloadTemplate(this, this.$t('lang.用户导入模版') + '.xlsx');
    },
    handleChangeFile(file) {
      const vm = this;
      let {response: res} = file;
      if(res) {
        vm.$refs.upload.clearFiles();
        if(res.status != 200) {
          vm.$message.error(res.desc);
          return;
        }
        vm.$message.success(res.desc);
        vm.handleGetData();
      }
    },
    handleSearch() {
      this.pager.pageIndex = 1;
      this.pager.pageSize = 10;
      this.pager.itemCount = 0;
      this.handleGetData();
    },
    handleReset() {
      if (Object.keys(this.searchForm).length) {
        this.searchForm = {};
        this.pager.pageIndex = 1;
        this.pager.pageSize = 10;
        this.pager.itemCount = 0;
        this.time = "";
        this.handleGetData();
      }
    },

    handleEdit(e) {

      if (e && e.code) {
        this.$router.push({
          path: 'edit',
          query: {
            code: e.code
          }
        });
        return;
      }

      if (!this.selection.length) {
        this.$message({
          type: 'warning',
          message: this.$t('lang.未选择记录')
        });
        return;
      }

      if (this.selection.length > 1) {
        this.$message({
          type: 'warning',
          message: this.$t('lang.一次只能编辑一条数据')
        });
        return;
      }

      this.$router.push({
        path: 'edit',
        query: {
          code: this.selection[0].code
        }
      });
    },
    handleDelete(row) {


      let vm = this;

      vm.$confirm(vm.$t('lang.您现在正在进行删除操作'), vm.$t('lang.提示'), {
        confirmButtonText: vm.$t('lang.确定'),
        cancelButtonText: vm.$t('lang.取消'),
        type: 'warning'
      }).then(() => {

        vm.$http.post(vm.api.delete, vm.$qs.stringify({
          code: row.code
        })).then((resp) => {
          if (resp.data.status === 200) {
            vm.$message({
              type: 'success',
              message: resp.data.desc
            });
            vm.handleGetData();
          } else {
            vm.$message({
              type: 'error',
              message: resp.data.desc
            });

          }
        })


      }).catch(() => {
        // this.$message({
        //     type: 'info',
        //     message: '已取消删除'
        // });
      });

    },
    handleBatchDelete() {


      let vm = this;

      if (!this.selection.length) {
        this.$message({
          type: 'warning',
          message: vm.$t('lang.未选择记录')
        });
        return;
      }


      let codes = [];

      this.selection.forEach((e) => {
        codes.push(e.code);
      });


      this.$confirm(vm.$t('lang.您现在正在进行删除操作'), vm.$t('lang.提示'), {
        confirmButtonText: vm.$t('lang.确定'),
        cancelButtonText: vm.$t('lang.取消'),
        type: 'warning'
      }).then(() => {

        vm.$http.post(this.api.batchDelete, codes).then((resp) => {
          if (resp.data.status === 200) {
            vm.$message({
              type: 'success',
              message: resp.data.desc
            });
            vm.handleGetData();
          } else {
            vm.$message({
              type: 'error',
              message: resp.data.desc
            });

          }
        })


      }).catch(() => {
        // this.$message({
        //     type: 'info',
        //     message: '已取消删除'
        // });
      });


    },
    handleSelectionChange(selection) {
      console.log(selection);
      this.selection = selection;
    },
    handlePagerSizeChange(e) {
      this.pager.pageSize = e;
    },
    handlePagerIndexChange(e) {
      this.pager.pageIndex = e;
    },
    handleGetData() {
      let vm = this;
      this.searchParams.brandOwnerCode = JSON.parse(sessionStorage.getItem("login-user-info")).brandOwnerCode
      this.$http.post(this.api.list, this.$qs.stringify(this.searchParams)).then((resp) => {


        for (let key in resp.data.data) {
          if (resp.data.data[key] instanceof Array) {
            vm.tableData = resp.data.data[key];
          }
        }

        //处理分页
        vm.pager.pageIndex = resp.data.data.pager.pageIndex;
        vm.pager.pageSize = resp.data.data.pager.pageSize;
        vm.pager.itemCount = resp.data.data.pager.itemCount;

      })
    }
  },
  created() {

    for (let key in this.searchForm) {
      if (this.$route.query[key]) {
        this.searchForm[key] = this.$route.query[key];
      }
    }
  }
}
</script>

<style scoped>

</style>
